import _ from 'lodash';
import { create } from 'zustand';

export type InsightsFiltersStore = {
  insightsState: Record<
    string,
    Partial<Record<string, { expandedInsightIds: string[]; expandedInsightSummaryIds: string[] }>>
  >;
  projectInsightsState: Record<
    string,
    Partial<Record<string, { expandedInsightIds: string[]; expandedInsightSummaryIds: string[] }>>
  >;
  setExpandedInsightIds: (options: {
    expandedInsightIds: string[];
    insightTitle: string;
    groupBy: string;
    type: 'insightsState' | 'projectInsightsState';
  }) => void;
  setExpandedInsightSummaryIds: (options: {
    expandedInsightSummaryIds: string[];
    insightTitle: string;
    groupBy: string;
    type: 'insightsState' | 'projectInsightsState';
  }) => void;
};

const useInsightsStore = create<InsightsFiltersStore>()((set) => ({
  insightsState: {
    MasterFormat: {},
    UniFormat: {},
  },
  projectInsightsState: {
    MasterFormat: {},
    UniFormat: {},
  },
  setExpandedInsightIds: ({ insightTitle, groupBy, expandedInsightIds, type }) =>
    set((prevState) => ({
      ...prevState,
      [type]: {
        ...prevState[type],
        [groupBy]: {
          ...prevState?.[type]?.[groupBy],
          [insightTitle]: {
            ...prevState?.[type]?.[groupBy]?.[insightTitle],
            expandedInsightIds,
          },
        },
      },
    })),
  setExpandedInsightSummaryIds: ({ insightTitle, groupBy, expandedInsightSummaryIds, type }) =>
    set((prevState) => ({
      ...prevState,
      [type]: {
        ...prevState[type],
        [groupBy]: {
          ...prevState?.[type]?.[groupBy],
          [insightTitle]: {
            ...prevState?.[type]?.[groupBy]?.[insightTitle],
            expandedInsightSummaryIds,
          },
        },
      },
    })),
}));

export default useInsightsStore;
